module.exports = __webpack_public_path__ + "img/IC_plan_planeado.cebcbb6d.svg";